import { render, staticRenderFns } from "./usercustomization.vue?vue&type=template&id=5740d81e"
import script from "./usercustomization.vue?vue&type=script&lang=js"
export * from "./usercustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports